import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { AdvancedFilter } from '../../../../sharedModule/models/advanced-filter.model';

@Injectable({
  providedIn: 'root',
})
export class AddFiltersService {
  private advancedFilterManageSideSubject = new Subject<AdvancedFilter>();
  private changeAdvancedFilterSubject = new Subject<string | AdvancedFilter>();

  constructor(public dialog: MatDialog) {}

  emitAdvancedFilter(filter) {
    this.advancedFilterManageSideSubject.next(filter);
  }
  advancedFilterListener(): Observable<any> {
    return this.advancedFilterManageSideSubject.asObservable();
  }

  changeFilter(filter) {
    this.changeAdvancedFilterSubject.next(filter);
  }
  changeFilterListener() {
    return this.changeAdvancedFilterSubject.asObservable();
  }
}
